<div class="content-wrapper d-print-none">
    <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">Pending Exit Clearance Authorization</h4>
                    <!-- <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                    </div> -->
                    <div class="table-responsive pt-3">
                        <nz-table #MovementTable [nzData]="Requests" [nzPageSize]="50">
                            <thead>

                                <tr>
                                    <th>
                                        #
                                    </th>

                                    <th>
                                        Reference
                                      </th>
                                      <th>
                                        Employee Name
                                      </th>

                                      <th>
                                        Designation
                                       
                                    </th>

                                      <th>
                                        Function
                                       </th>
                                      <th>
                                        Unit
                                      </th>
                    
                                      <th>
                                        Phone Number  
                                      </th>
                                      <th>
                                      Last Working Date 
                                      </th>
                                   

                                    <th>
                                        Status
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of MovementTable.data; let i = index ;">

                                    <td>
                                        {{i+1}}
                                    </td>

                                    <td>{{data.exitClearance.reference}}</td>
                                    <td>{{data.exitClearance.employeeName}}</td>
                                    <td>{{data.exitClearance.employeeDesignation}}</td>
                                    <td>{{data.exitClearance.employeeFunctionName}}</td>
                                    <td>{{data.exitClearance.employeeUnitName}}</td>
                                    <td>{{data.exitClearance.employeePhoneNumber}}</td>
                                    <td>{{data.exitClearance.employeeLastWorkingDate | date: 'dd MMMM yyyy'}}</td>
                                    <td>
                                        <button [ngClass]="getStatusColor(data.exitClearance.status)"> {{data.exitClearance.status}}</button>
                                    </td>
                                    <td>

                                        <div class="dropdown">
                                            <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                         
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">

                                                <a class="dropdown-item" (click)="open(data)">View</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" (click)="openapproval(data)">View Approvals</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" (click)="AuthorizeClearance(data.exitClearance)">Authorize</a>
                                                <!-- <a class="dropdown-item"   nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                                                (nzOnConfirm)="beginCancel(data)"  *ngIf="canCreateMovement &&  data.status =='Pending'"  (nzOnCancel)="cancel()">Cancel Request</a> -->


                                            </div>
                                        </div>


                                    </td>
                                </tr>
                            </tbody>
                        </nz-table>

                    </div>
                </div>
            </div>
        </div>


    </div>
</div>
<!-- Context Menu  -->
<nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
        <li nz-menu-item>1st menu item</li>
        <li nz-menu-item>2nd menu item</li>
        <li nz-menu-divider></li>
    </ul>
</nz-dropdown-menu>


            <!-- View Pending Request Approval Modal  -->
            <nz-modal [(nzVisible)]="isPendingpprovalModalVisible" nzTitle="Request Approvals" [nzWidth]="800" (nzOnCancel)="handleCancel()" [nzCancelText]="null" (nzOnOk)="handleCancel()" nzOkText="OK">

                <div *nzModalContent>

                    <div class="table-responsive">
                        <table class="table table--striped table-hover">
                            <thead>
                                <tr>

                                    <th>
                                        Description
                                    </th>
                                    <th>
                                        Approver
                                    </th>
                                    <th>
                                        Status
                                    </th>

                                    <th>
                                        Approval Date
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let approval of ExitRequestApprovals">

                                    <td>{{approval.description}}</td>
                                    <td>{{approval.approverEmail }}</td>
                                    <td><button  [ngClass]="getStatusColor(approval.status)">{{ approval.status }}</button></td>

                                    <td>{{approval.approvalDate | date: 'medium'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>


            </nz-modal>

            <nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040" [nzVisible]="ViewExitRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

                <!-- Side swipe content -->

<div class="row d-print-block" id="detailSection">
    <div class="col-lg-12 grid-margin stretch-card">
    <div class="card">
       <div class="row">
          <div class="col">
             <h5 class="card-title">Exit Clearance Details</h5>
          </div>
          <div class="col">
             <img src="../../../assets/images/holcim_logo_color.svg" alt="" srcset="" style="height: 30px;">
          </div>
       </div>
       <h5> DETAILS</h5>
       <br>
       <div class="row">
          <div class="col">
             <label><b>Request Reference</b></label>
             <p>{{ ExitRequest?.reference }}</p>
          </div>
          <div class="col">
             <label><b>Employee Name</b></label>
             <p>{{ ExitRequest?.employeeName }}</p>
          </div>
       </div>
       <div class="row">
          <div class="col">
             <label><b>Function</b></label>
             <p>{{ ExitRequest?.employeeFunctionName }}</p>
          </div>
          <div class="col">
             <label><b>Employee Unit</b></label>
             <p>{{ ExitRequest?.employeeUnitName }}</p>
          </div>
       </div>
       <div class="row">
          <div class="col">
             <label><b>Employee Designation</b></label>
             <p>{{ ExitRequest?.employeeDesignation }}</p>
          </div>
          <div class="col">
             <label><b>Last Working Date</b></label>
             <p>{{ ExitRequest?.employeeLastWorkingDate | date: 'medium'}}</p>
          </div>
       </div>
       <div class="row">
        <div class="col">
           <label><b>Date Created</b></label>
           <p>{{ ExitRequest?.createdDate | date: 'medium'}}</p>
        </div>
        <div class="col">
           <label><b>Initiated By</b></label>
           <p>{{ ExitRequest?.createdBy }}</p>
        </div>
     </div>
     <div class="row">
        <div class="col">
           <label><b>Line Manager</b></label>
           <p>{{ ExitRequest?.lineManagerName }}</p>
        </div>
        <div class="col">
           <label><b>HRBP</b></label>
           <p>{{ ExitRequest?.hrbpName }}</p>
        </div>
     </div>

     <div class="row">
        <div class="col">
           <label><b>Employee Personal Email</b></label>
           <p>{{ ExitRequest?.employeePersonalEmail }}</p>
        </div>
        <div class="col">
           <label><b>Employee Permanent Address</b></label>
           <p>{{ ExitRequest?.employeePermanentAddress }}</p>
        </div>
     </div>
     <div class="row">
        <div class="col">
           <label><b>Status</b></label>
           <p>{{ ExitRequest?.status }}</p>
        </div>
        <div class="col">
            <label><b>Reason For Exit</b></label>
            <p >{{ ExitRequest?.reasonForExit }}</p>
         </div>
     </div>
         <hr>
       <div class="card-body">
          <h5 class="card-title">Pending Approvals</h5>
          <div class="table-responsive" *ngIf="MyPendingExitRequestApprovals?.length">
             <table class="table table--striped table-hover">
                <thead>
                   <tr>
                    <th>
                        Description
                    </th>
                    <th>
                        Approver
                    </th>
                    <th>
                        Status
                    </th>

                    <th>
                        Approval Date
                    </th>
                   </tr>
                </thead>
                <tbody>
                   <tr *ngFor="let approval of MyPendingExitRequestApprovals">
                      <td>{{approval.description}}</td>
                      <td>{{approval.approvedBy}}</td>
                      <td>{{approval.status}}</td>
                      <td>{{approval.approvalDate | date: 'medium'}}</td>
                    
                   </tr>
                </tbody>
             </table>
          </div>
          <div *ngIf="!MyPendingExitRequestApprovals?.length" style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
             <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
          </div>
       </div>
    </div>
    
        <!-- Side swipe content ends -->
        <ng-template #footerTpl>
            <div style="float: right" class="d-print-none">

                <button class="btn btn-primary" style="margin-right: 8px;"   *ngIf="ExitRequest?.status === 'Approved' || ExitRequest?.status === 'Closed'">Print</button>
                <!-- <button class="btn btn-primary" style="margin-right: 8px;" (click)="print(ExitRequest, 'detailSection')" *ngIf="ExitRequest?.status === 'Approved' || ExitRequest?.status === 'Closed'">Print</button> -->

                <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;" (click)="close()">Close</button>
            </div>


        </ng-template>